import { Package } from '../service-case/model/package';
import { ValueUpdater } from '../valueUpdater';
import { DefectTransformer } from './defectTransformer';
import { FlatRateUnitTransformer } from './flatRateUnitTransformer';
import { PartTransformer } from './partTransformer';
import { PackageV10 } from './v10/case/model/packageV10';
import { PackageV11 } from './v11/service-case/model/packageV11';
export class PackageTransformer {
    static transformList(inVersion, outVersion, payload) {
        const resultList = [];
        payload.forEach((servicePackage) => {
            resultList.push(this.transform(inVersion, outVersion, servicePackage));
        });
        return resultList;
    }
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '12-to-11':
                return PackageV11.constructFromPlainObject(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            case '11-to-12':
                return Package.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV10(payload) {
        var _a;
        const servicePackage = Package.constructFromPlainObject(payload);
        const packageV10 = new PackageV10(servicePackage.getDescription(), servicePackage.getNumber(), servicePackage.getType(), DefectTransformer.transformList(12, 10, servicePackage.getDefects()), FlatRateUnitTransformer.transformList(12, 10, servicePackage.getFlatRateUnits()), PartTransformer.transformList(12, 10, servicePackage.getParts()), (_a = servicePackage.getCampaignBegin()) !== null && _a !== void 0 ? _a : undefined, servicePackage.getCampaignName(), servicePackage.getCampaignNumber());
        packageV10.setPositionNumber(ValueUpdater.updateNonNullableNumberOrUnknown(packageV10.getPositionNumber(), servicePackage.getPositionNumber()));
        packageV10.setSelected(ValueUpdater.updateNonNullableField(packageV10.isSelected(), servicePackage.getIsSelected()));
        return packageV10;
    }
    static transformFromV10ToV12(payload) {
        const packageV10 = PackageV10.constructFromPlainObject(payload);
        const servicePackage = new Package(packageV10.getNumber(), packageV10.getDescription(), packageV10.getType());
        servicePackage.setCampaignBegin(ValueUpdater.updateNullableField(servicePackage.getCampaignBegin(), packageV10.getCampaignBegin()));
        servicePackage.setCampaignName(ValueUpdater.updateNonNullableString(servicePackage.getCampaignName(), packageV10.getCampaignName()));
        servicePackage.setCampaignNumber(ValueUpdater.updateNonNullableString(servicePackage.getCampaignNumber(), packageV10.getCampaignNumber()));
        servicePackage.setDefects(DefectTransformer.transformList(10, 12, packageV10.getDefects()));
        servicePackage.setFlatRateUnits(FlatRateUnitTransformer.transformList(10, 12, packageV10.getFlatRateUnits()));
        servicePackage.setIsSelected(ValueUpdater.updateNonNullableField(servicePackage.getIsSelected(), packageV10.isSelected()));
        servicePackage.setParts(PartTransformer.transformList(10, 12, packageV10.getParts()));
        servicePackage.setPositionNumber(ValueUpdater.updateNullableField(servicePackage.getPositionNumber(), packageV10.getPositionNumber()));
        return servicePackage;
    }
}
//# sourceMappingURL=packageTransformer.js.map